import {
	Component,
	EventEmitter,
	Input,
	Output,
	ViewEncapsulation,
} from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';

import { TabModel } from './tab.model';

@Component({
	encapsulation: ViewEncapsulation.None,
	selector: 'app-tab',
	// styleUrls: ['assets/styles/components/_tabs.scss'],
	templateUrl: './tab.component.html',
})
export class TabComponent {
	@Output() action: EventEmitter<string> = new EventEmitter();

	@Input() public tabs: TabModel[] = [];

	public active: string = '';

	@Input() public set navTab(value: string) {
		if (!value) {
			this.active = this.tabs[0]?.path || '';
		} else {
			setTimeout(() => {
				this.active = value;
			}, 1);
		}
	}

	getSelectedIndex(): number {
		return this.tabs.findIndex((tab) => tab.path === this.active);
	}

	onTabChange(event: MatTabChangeEvent): void {
		const selectedTab = this.tabs[event.index];

		if (selectedTab) {
			this.active = selectedTab.path;
			this.action.emit(selectedTab.path);
		}
	}

	trackByTab(index: number, tab: TabModel): string {
		return tab.path;
	}
}
